import { Button } from '../ui/button'
import { Modal, ModalProps } from './Modal'
import IconAttention from '@/assets/icons/ic_logic-g-app_attention.svg'

interface Props extends ModalProps {
  nickname: string
  onOk: () => void
}

export const DeleteGuardianModal = ({
  isOpen,
  nickname,
  onOk,
  ...rest
}: Props): JSX.Element => {
  return (
    <Modal
      isOpen={isOpen}
      customStyles={{
        content: {
          padding: '48px 35px',
        },
      }}
      {...rest}
    >
      <h3 className="text-2xl text-primary-text text-center font-bold mt-[10px] mb-[15px] tracking-widest">
        本当に削除しますか
      </h3>

      <p className="text-center text-[15px] text-secondary-text font-medium tracking-widest">
        <span>{nickname}</span>
        の登録を削除します。このそうさは取り消せません。
      </p>

      <div className="text-[#D7DDF3] flex justify-center mt-9">
        <IconAttention width={104} aria-hidden={true} />
      </div>

      <Button
        className="w-full mt-[88px]"
        onClick={onOk}
      >
        削除
      </Button>
    </Modal>
  )
}
